import { api } from '@/lib/axios';

export type PlanTier = 'FREE' | 'PRO' | 'BUSINESS' | 'ENTERPRISE';

export interface Subscription {
  tier: PlanTier;
  status: string;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  maxParticipants: number;
  maxDurationMins: number;
  maxStorageGb: number;
}

export const PLAN_INFO: { tier: PlanTier; name: string; price: string; features: string[] }[] = [
  { tier: 'FREE', name: 'Free', price: '$0', features: ['100 participants', '40 min meetings', '1 GB storage'] },
  { tier: 'PRO', name: 'Pro', price: '$15/mo', features: ['300 participants', 'Unlimited duration', '50 GB storage', 'Cloud recording'] },
  { tier: 'BUSINESS', name: 'Business', price: '$30/mo', features: ['500 participants', 'Unlimited duration', '200 GB storage', 'Admin controls'] },
  { tier: 'ENTERPRISE', name: 'Enterprise', price: '$50/mo', features: ['1000 participants', 'Unlimited duration', '1 TB storage', 'SSO & priority support'] },
];

export const billingApi = {
  async getSubscription(): Promise<Subscription> {
    const { data } = await api.get('/billing/subscription');
    return data.data;
  },
  async checkout(tier: Exclude<PlanTier, 'FREE'>): Promise<string> {
    const { data } = await api.post('/billing/checkout', { tier });
    return data.data.url as string;
  },
  async portal(): Promise<string> {
    const { data } = await api.post('/billing/portal');
    return data.data.url as string;
  },
};
